(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
(() => {
  if (customElements.get('deryan-pearl-cart')) return;
  const pearlTimerKey = 'deryan-pearl-cart-timer-start-v2';
  const pearlTimerLegacyKey = 'deryan-pearl-cart-timer-v1';
  let pearlTimerMemory = null;
  customElements.whenDefined('cart-drawer').then(() => {
    if (customElements.get('deryan-pearl-cart')) return;
    const BaseDrawer = customElements.get('cart-drawer');
    class DeryanPearlCart extends BaseDrawer {
      _setInitialPosition() {}
      get initialFocus() { return '#cart-drawer .pearl-close'; }
      get pearlReduceMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches || !!window.themeVariables?.settings?.reduceDrawerAnimation;
      }
      pearlAnimate(element, frames, options = {}) {
        if (!element || this.pearlReduceMotion) return null;
        this.pearlAnimations ||= new Set();
        const animation = element.animate(frames,{duration:420,easing:'cubic-bezier(.16,1,.3,1)',fill:'backwards',...options});
        this.pearlAnimations.add(animation);
        animation.finished.catch(() => {}).finally(() => this.pearlAnimations.delete(animation));
        return animation;
      }
      _showTransition(animate = true) { return this.pearlTransition(true,animate); }
      _hideTransition() { return this.pearlTransition(false); }
      async pearlTransition(open, animate = true) {
        this.syncCountdown(open);
        const revision = this.pearlMotionRevision = (this.pearlMotionRevision || 0) + 1;
        const content = this.shadowRoot.querySelector('[part="content"]');
        const overlay = this.shadowRoot.querySelector('[part="overlay"]');
        const current = {opacity:getComputedStyle(content).opacity,transform:getComputedStyle(content).transform};
        const overlayOpacity = getComputedStyle(overlay).opacity;
        const interrupted = this.pearlPanelAnimation?.playState === 'running';
        this.pearlAnimations?.forEach(animation => animation.cancel());
        clearTimeout(this.pearlEntranceTimeout);
        this.classList.remove('pearl-entering');
        this.style.visibility = 'visible';
        this.style.opacity = '1';
        content.style.clipPath = 'none';
        const mobile = window.matchMedia('(max-width:600px)').matches;
        const duration = !animate || this.pearlReduceMotion ? 0 : open ? mobile ? 420 : 520 : 210;
        const movement = mobile ? 'translate3d(0,24px,0) scale(.985)' : 'translate3d(48px,8px,0) scale(.975)';
        const panel = this.pearlPanelAnimation = duration ? this.pearlAnimate(content,open ? [interrupted ? current : {opacity:0,transform:movement},{opacity:1,transform:'none'}] : [current,{opacity:0,transform:movement}],{duration,easing:open ? 'cubic-bezier(.16,1,.3,1)' : 'cubic-bezier(.4,0,1,1)'}) : null;
        if (duration) this.pearlAnimate(overlay,[{opacity:interrupted ? overlayOpacity : open ? 0 : 1},{opacity:open ? 1 : 0}],{duration:open ? 360 : 200});
        if (open && duration && !interrupted) {
          this.pearlEnter(mobile);
        }
        await panel?.finished.catch(() => {});
        if (revision !== this.pearlMotionRevision) return;
        this.classList.toggle('show-close-cursor',open);
        if (!open) { this.style.visibility = 'hidden'; this.style.opacity = '0'; }
      }
      pearlEnter(mobile) {
        const reveal = (element,delay,distance = 12) => this.pearlAnimate(element,[{opacity:0,transform:'translate3d(0,'+distance+'px,0)'},{opacity:1,transform:'none'}],{duration:mobile ? 340 : 430,delay});
        reveal(this.querySelector('.pearl-header'),30,8);
        reveal(this.querySelector('.pearl-countdown'),55,8);
        reveal(this.querySelector('.pearl-shipping'),75,8);
        this.querySelectorAll('[data-pearl-line]').forEach((line,index) => {
          const delay = 90 + Math.min(index,4)*35;
          reveal(line,delay);
          this.pearlAnimate(line.querySelector('.pearl-item-image img'),[{opacity:.3,transform:'scale(.94)'},{opacity:1,transform:'scale(1)'}],{duration:480,delay});
        });
        reveal(this.querySelector('.pearl-recommendations h3'),125,6);
        this.querySelectorAll('.pearl-recommendation').forEach((card,index) => reveal(card,145+index*40,14));
        reveal(this.querySelector('.pearl-footer'),85,8);
        reveal(this.querySelector('.pearl-empty'),75);
        this.classList.add('pearl-entering');
        this.pearlEntranceTimeout = setTimeout(() => this.classList.remove('pearl-entering'),1100);
      }
      connectedCallback() {
        super.connectedCallback();
        this.pearlAbort?.abort();
        this.pearlAbort = new AbortController();
        const options = {signal:this.pearlAbort.signal};
        this.pearlMotionMedia = window.matchMedia('(prefers-reduced-motion: reduce)');
        const syncMotion = () => {
          this.toggleAttribute('data-pearl-reduced-motion',this.pearlReduceMotion);
          if (this.pearlReduceMotion) {
            this.pearlAnimations?.forEach(animation => animation.cancel());
            this.classList.remove('pearl-entering');
          }
        };
        syncMotion();
        this.pearlMotionMedia.addEventListener('change',syncMotion,options);
        this.addEventListener('toggle', event => { if (event.target === this) this.syncWidget(); }, options);
        this.syncWidget();
        this.localizeShipping();
        this.pearlLanguageObserver?.disconnect();
        this.pearlLanguageObserver = new MutationObserver(() => this.localizeShipping());
        this.pearlLanguageObserver.observe(document.documentElement,{attributes:true,attributeFilter:['lang']});
        this.syncCountdown();
        document.addEventListener('visibilitychange', () => this.syncCountdown(), options);
        window.addEventListener('pageshow', () => this.syncCountdown(), options);
        window.addEventListener('storage', event => {
          if (window.Shopify?.designMode || event.key !== pearlTimerKey) return;
          pearlTimerMemory = Number(event.newValue) || null;
          if (pearlTimerMemory) this.syncCountdown();
          else {
            clearInterval(this.pearlCountdownInterval);
            const banner = this.querySelector('[data-pearl-countdown]');
            if (banner) banner.hidden = true;
          }
        }, options);
        this.addEventListener('click', e => this.handleClick(e), options);
        this.addEventListener('change', e => this.handleChange(e), options);
        this.addEventListener('submit', e => this.handleSubmit(e), options);
        this.addEventListener('keydown', e => {
          if (e.key === 'Enter' && e.target.matches('[data-pearl-quantity]')) {
            e.preventDefault(); e.target.blur();
          }
        }, options);
        if (performance.getEntriesByType('navigation')[0]?.type === 'back_forward') this._onCartRefresh();
      }
      disconnectedCallback() {
        super.disconnectedCallback();
        this.pearlAbort?.abort();
        this.pearlLanguageObserver?.disconnect();
        this.pearlAnimations?.forEach(animation => animation.cancel());
        clearInterval(this.pearlCountdownInterval);
        clearTimeout(this.pearlEntranceTimeout);
        this.restoreWidget();
      }
      syncCountdown(isOpen = this.open) {
        clearInterval(this.pearlCountdownInterval);
        if (!this.querySelector('[data-pearl-line]')) {
          this.pearlEditorTimer = null;
          if (!window.Shopify?.designMode) {
            pearlTimerMemory = null;
            try { localStorage.removeItem(pearlTimerKey); localStorage.removeItem(pearlTimerLegacyKey); } catch (_) {}
          }
          return;
        }
        const banner = this.querySelector('[data-pearl-countdown]');
        if (!banner || !isOpen || document.hidden) return;
        const minutes = Math.min(60,Math.max(1,Math.round(Number(banner.dataset.durationMinutes) || 10)));
        const duration = minutes * 60 * 1000;
        const now = Date.now();
        let started;
        if (window.Shopify?.designMode) {
          if (!this.pearlEditorTimer || this.pearlEditorTimer.duration !== duration) this.pearlEditorTimer = {started:now,duration};
          started = this.pearlEditorTimer.started;
        } else {
          try {
            pearlTimerMemory = Number(localStorage.getItem(pearlTimerKey)) || pearlTimerMemory;
            if (!pearlTimerMemory) {
              const legacyDeadline = Number(localStorage.getItem(pearlTimerLegacyKey));
              if (legacyDeadline > 0 && legacyDeadline <= now + 600000) pearlTimerMemory = legacyDeadline - 600000;
            }
          } catch (_) {}
          if (!Number.isFinite(pearlTimerMemory) || pearlTimerMemory <= 0 || pearlTimerMemory > now) pearlTimerMemory = now;
          try {
            localStorage.setItem(pearlTimerKey,String(pearlTimerMemory));
            localStorage.removeItem(pearlTimerLegacyKey);
          } catch (_) {}
          started = pearlTimerMemory;
        }
        const deadline = started + duration;
        const value = banner.querySelector('[data-pearl-timer-value]');
        const active = banner.querySelector('[data-pearl-timer-active]');
        const ended = banner.querySelector('[data-pearl-timer-ended]');
        const tick = () => {
          const seconds = Math.max(0,Math.min(minutes * 60,Math.ceil((deadline-Date.now())/1000)));
          value.textContent = String(Math.floor(seconds/60)).padStart(2,'0')+':'+String(seconds%60).padStart(2,'0');
          value.hidden = seconds === 0;
          active.hidden = seconds === 0;
          ended.hidden = seconds > 0;
          banner.hidden = false;
          if (seconds === 0) clearInterval(this.pearlCountdownInterval);
          return seconds;
        };
        if (tick() > 0) this.pearlCountdownInterval = setInterval(tick,1000);
      }
      restoreWidget() {
        this.pearlWidgetObserver?.disconnect();
        if (this.pearlWidget) {
          const {element,value,priority} = this.pearlWidget;
          if (value) element.style.setProperty('display',value,priority);
          else element.style.removeProperty('display');
          this.pearlWidget = null;
        }
      }
      syncWidget() {
        if (!this.open) { this.restoreWidget(); return; }
        const hide = () => {
          const element = document.querySelector('[data-minimal-storefront-widget-shell]');
          if (!element) return false;
          if (!this.pearlWidget) this.pearlWidget = {element,value:element.style.getPropertyValue('display'),priority:element.style.getPropertyPriority('display')};
          if (element.style.getPropertyValue('display') !== 'none') element.style.setProperty('display','none','important');
          return element;
        };
        this.pearlWidgetObserver?.disconnect();
        const element = hide();
        this.pearlWidgetObserver = new MutationObserver(() => {
          const found = hide();
          if (found && !element) { this.pearlWidgetObserver.disconnect(); this.pearlWidgetObserver.observe(found,{attributes:true,attributeFilter:['style']}); }
        });
        if (element) this.pearlWidgetObserver.observe(element,{attributes:true,attributeFilter:['style']});
        else this.pearlWidgetObserver.observe(document.body,{childList:true,subtree:true});
      }
      messages() {
        try { return JSON.parse(this.querySelector('[data-pearl-messages]').textContent); }
        catch (_) { return {}; }
      }
      localizeShipping() {
        const shipping = this.querySelector('.pearl-shipping');
        if (!shipping) return;
        const hostLanguage = /^(nl|en|de|fr|es|it|da|sv|pl|no)\.deryan\.com$/.exec(location.hostname)?.[1];
        let weglotLanguage;
        try { weglotLanguage = window.Weglot?.getCurrentLang?.(); } catch (_) {}
        const language = (weglotLanguage || hostLanguage || document.documentElement.lang || 'nl').toLowerCase().split('-')[0];
        let translations;
        try { translations = JSON.parse(shipping.querySelector('[data-pearl-shipping-languages]').textContent); } catch (_) { return; }
        const copy = translations[language] || translations.en;
        const message = shipping.querySelector('[data-pearl-shipping-copy]');
        if (!copy || !message) return;
        message.setAttribute('data-wg-notranslate','');
        const state = shipping.dataset.shippingState;
        if (state === 'away') {
          const [before,after = ''] = copy.away.split('__PEARL_AMOUNT__');
          const amount = document.createElement('strong');
          amount.setAttribute('data-wg-notranslate','');
          amount.textContent = shipping.dataset.remainingFormatted;
          message.replaceChildren(document.createTextNode(before),amount,document.createTextNode(after));
        } else message.textContent = copy[state] || copy.calculated;
        const track = shipping.querySelector('[role="progressbar"]');
        if (track) track.setAttribute('aria-label',copy.progress);
      }
      setBusy(busy) {
        this.pearlBusy = busy;
        if (busy) this.setAttribute('aria-busy','true');
        else this.removeAttribute('aria-busy');
        const controls = this.querySelectorAll('[data-pearl-step],[data-pearl-quantity],[data-pearl-add],[data-pearl-checkout]');
        controls.forEach(control => {
          if (busy) {
            if (!control.disabled) { control.dataset.pearlLocked = 'true'; control.disabled = true; }
          } else if (control.dataset.pearlLocked) {
            control.disabled = false; delete control.dataset.pearlLocked;
          }
        });
      }
      handleClick(event) {
        const button = event.target.closest('[data-pearl-step],[data-pearl-remove]');
        if (!button) return;
        event.preventDefault();
        if (this.pearlBusy || button.disabled) return;
        const line = button.closest('[data-pearl-line]');
        const input = line.querySelector('[data-pearl-quantity]');
        const quantity = button.hasAttribute('data-pearl-remove') ? 0 : Number(input.value) + Number(button.dataset.pearlStep);
        if (!Number.isInteger(quantity) || quantity < 0 || quantity > Number(input.max)) return;
        this.mutate('change', {id:line.dataset.lineKey,quantity},button);
      }
      handleChange(event) {
        const input = event.target;
        if (!input.matches('[data-pearl-quantity]')) return;
        const quantity = Number(input.value);
        if (this.pearlBusy || input.value.trim() === '' || !Number.isInteger(quantity) || quantity < 0 || quantity > Number(input.max)) {
          input.value = input.dataset.previous;
          return;
        }
        if (quantity !== Number(input.dataset.previous)) this.mutate('change',{id:input.closest('[data-pearl-line]').dataset.lineKey,quantity});
      }
      handleSubmit(event) {
        if (!event.target.matches('.pearl-add-form')) return;
        event.preventDefault();
        if (this.pearlBusy) return;
        const form = event.target;
        if (!form.reportValidity()) return;
        this.mutate('add',{items:[{id:form.elements.id.value,quantity:1}]},form.querySelector('[data-pearl-add]'));
      }
      focusToken() {
        const active = document.activeElement;
        if (!this.contains(active)) return null;
        const line = active.closest('[data-pearl-line]');
        if (line) return {key:line.dataset.lineKey,step:active.dataset.pearlStep,quantity:active.hasAttribute('data-pearl-quantity'),remove:!!active.closest('[data-pearl-remove]')};
        return {checkout:active.hasAttribute('data-pearl-checkout'),add:!!active.closest('.pearl-add-form')};
      }
      renderCart(html, focus = this.pearlFocus || this.focusToken()) {
        if (!html) return false;
        const source = new DOMParser().parseFromString(html,'text/html').querySelector('#cart-drawer');
        if (!source) return false;
        const scroller = this.shadowRoot?.querySelector('[part="body"]');
        const scrollTop = scroller?.scrollTop || 0;
        const previousLines = new Map([...this.querySelectorAll('[data-pearl-line]')].map(line => [line.dataset.lineKey,{top:line.getBoundingClientRect().top,quantity:Number(line.querySelector('[data-pearl-quantity]')?.value)}]));
        const previousCards = new Map([...this.querySelectorAll('.pearl-recommendation')].map(card => [card.querySelector('a')?.getAttribute('href'),card.getBoundingClientRect().top]));
        const previousHeading = this.querySelector('.pearl-recommendations h3')?.getBoundingClientRect().top;
        const previousTotal = this.querySelector('.pearl-total-values strong')?.textContent;
        const previousCount = this.querySelector('.pearl-count')?.textContent;
        const previousShipping = this.querySelector('.pearl-shipping-track')?.getAttribute('aria-valuenow');
        this.replaceChildren(...source.childNodes);
        this.localizeShipping();
        this.syncCountdown();
        if (scroller) scroller.scrollTop = scrollTop;
        if (this.open && !this.pearlReduceMotion) {
          this.querySelectorAll('[data-pearl-line]').forEach(line => {
            const before = previousLines.get(line.dataset.lineKey);
            const distance = before === undefined ? 16 : before.top-line.getBoundingClientRect().top;
            if (before === undefined || Math.abs(distance) > 1) this.pearlAnimate(line,[{opacity:before === undefined ? 0 : 1,transform:'translateY('+distance+'px)'},{opacity:1,transform:'none'}],{duration:440});
            if (before === undefined) this.pearlAnimate(line.querySelector('.pearl-item-image img'),[{transform:'scale(.88)'},{transform:'scale(1)'}],{duration:520});
            const quantity = line.querySelector('[data-pearl-quantity]');
            if (before && quantity && before.quantity !== Number(quantity.value)) {
              const direction = Number(quantity.value) > before.quantity ? 1 : -1;
              this.pearlAnimate(quantity,[{opacity:.3,transform:'translateY('+direction*7+'px)'},{opacity:1,transform:'none'}],{duration:300});
              this.pearlAnimate(line.querySelector('.pearl-line-price strong'),[{opacity:.4,transform:'translateY(4px)'},{opacity:1,transform:'none'}],{duration:320});
            }
          });
          this.querySelectorAll('.pearl-recommendation').forEach((card,index) => {
            const before = previousCards.get(card.querySelector('a')?.getAttribute('href'));
            const distance = before === undefined ? 12 : before-card.getBoundingClientRect().top;
            if (before === undefined || Math.abs(distance) > 1) this.pearlAnimate(card,[{opacity:before === undefined ? 0 : 1,transform:'translateY('+distance+'px)'},{opacity:1,transform:'none'}],{duration:440,delay:before === undefined ? index*30 : 0});
          });
          const heading = this.querySelector('.pearl-recommendations h3');
          if (heading && previousHeading !== undefined) {
            const distance = previousHeading-heading.getBoundingClientRect().top;
            if (Math.abs(distance) > 1) this.pearlAnimate(heading,[{transform:'translateY('+distance+'px)'},{transform:'none'}],{duration:440});
          }
          const total = this.querySelector('.pearl-total-values strong');
          if (total && total.textContent !== previousTotal) this.pearlAnimate(total,[{opacity:.3,transform:'translateY(6px)'},{opacity:1,transform:'none'}],{duration:360});
          const count = this.querySelector('.pearl-count');
          if (count && count.textContent !== previousCount) this.pearlAnimate(count,[{transform:'scale(.9)'},{transform:'scale(1.12)',offset:.45},{transform:'scale(1)'}],{duration:380});
          const track = this.querySelector('.pearl-shipping-track');
          if (track && previousShipping !== null && previousShipping !== undefined) {
            const from = Number(previousShipping), to = Number(track.getAttribute('aria-valuenow'));
            if (from !== to && to > 0) this.pearlAnimate(track.firstElementChild,[{transform:'scaleX('+from/to+')'},{transform:'scaleX(1)'}],{duration:620});
            if (from < 100 && to >= 100) this.pearlAnimate(this.querySelector('.pearl-shipping-message svg'),[{transform:'scale(.8)'},{transform:'scale(1.16)',offset:.5},{transform:'scale(1)'}],{duration:480,delay:180});
          }
        }
        if (this.hasAttribute('open') && focus) {
          const line = [...this.querySelectorAll('[data-pearl-line]')].find(el=>el.dataset.lineKey === focus.key);
          let target = null;
          if (line) {
            target = focus.quantity ? line.querySelector('[data-pearl-quantity]') : focus.remove ? line.querySelector('[data-pearl-remove]') : line.querySelector('[data-pearl-step="'+focus.step+'"]');
          }
          if (!target || target.disabled) target = this.querySelector('[data-pearl-checkout]') || this.querySelector('[is="close-button"]');
          target?.focus({preventScroll:true});
        }
        return true;
      }
      async _onCartChanged(event) {
        const cart = event.detail?.cart;
        if (!cart) return;
        this.pearlRevision = (this.pearlRevision || 0) + 1;
        const html = cart.sections?.[this.dataset.sectionId];
        if (!this.renderCart(html)) await this._onCartRefresh();
        if (this.pearlBusy) this.setBusy(true);
        const status = this.querySelector('[data-pearl-status]');
        if (status) status.textContent = this.messages().updated || '';
      }
      async _onCartRefresh() {
        const revision = this.pearlRevision = (this.pearlRevision || 0) + 1;
        try {
          const url = new URL(window.Shopify.routes.root,location.origin);
          url.searchParams.set('section_id',this.dataset.sectionId);
          url.searchParams.set('_pearl',String(Date.now()));
          const [response,cartResponse] = await Promise.all([
            fetch(url,{credentials:'same-origin',cache:'no-store'}),
            fetch(window.Shopify.routes.root+'cart.js',{credentials:'same-origin',cache:'no-store'})
          ]);
          if (!response.ok || !cartResponse.ok) throw new Error();
          const [html,cart] = await Promise.all([response.text(),cartResponse.json()]);
          if (revision === this.pearlRevision) {
            cart.sections = {[this.dataset.sectionId]:html};
            document.documentElement.dispatchEvent(new CustomEvent('cart:change',{bubbles:true,detail:{baseEvent:'cart:refresh',cart}}));
          }
        } catch (_) { this.showError(this.messages().error); }
      }
      showError(message) {
        const error = this.querySelector('[data-pearl-error]');
        if (error) { error.textContent = message || this.messages().error || ''; error.hidden = false; }
      }
      async mutate(action,payload,control = null) {
        if (this.pearlBusy) return;
        this.pearlFocus = this.focusToken();
        this.setBusy(true);
        control?.setAttribute('data-pearl-pending','');
        const error = this.querySelector('[data-pearl-error]');
        if (error) error.hidden = true;
        const sections = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections',{bubbles:true,detail:{sections}}));
        payload.sections = [...new Set(sections)].slice(0,5);
        if (!payload.sections.includes(this.dataset.sectionId)) payload.sections = [this.dataset.sectionId,...payload.sections].slice(0,5);
        payload.sections_url = location.pathname;
        const root = window.Shopify.routes.root;
        try {
          const response = await fetch(root+'cart/'+action+'.js',{
            method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify(payload)
          });
          const result = await response.json();
          if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : this.messages().error);
          let cart = result;
          if (action === 'add') {
            const cartResponse = await fetch(root+'cart.js',{credentials:'same-origin',cache:'no-store'});
            if (!cartResponse.ok) throw new Error(this.messages().error);
            cart = await cartResponse.json(); cart.sections = result.sections;
          }
          if (action === 'change' && payload.quantity === 0 && this.open) {
            const line = [...this.querySelectorAll('[data-pearl-line]')].find(item => item.dataset.lineKey === payload.id);
            const exit = this.pearlAnimate(line,[{opacity:1,transform:'none'},{opacity:0,transform:'translateX(18px) scale(.98)'}],{duration:150,easing:'cubic-bezier(.4,0,1,1)'});
            await exit?.finished.catch(() => {});
          }
          this.setBusy(false);
          document.documentElement.dispatchEvent(new CustomEvent('cart:change',{bubbles:true,detail:{baseEvent:action === 'add' ? 'variant:add' : 'line-item:change',cart}}));
          if (action === 'add') this.dispatchEvent(new CustomEvent('variant:add',{bubbles:true,detail:{items:result.items || [result],cart}}));
        } catch (error) {
          await this._onCartRefresh();
          this.showError(error.message || this.messages().error);
        } finally { control?.removeAttribute('data-pearl-pending'); this.setBusy(false); this.pearlFocus = null; }
      }
    }
    customElements.define('deryan-pearl-cart',DeryanPearlCart);
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deryan-pearl-header"]) return;
  try {
    
if (!customElements.get('deryan-pearl-language')) {
  customElements.define('deryan-pearl-language',class extends HTMLElement {
    connectedCallback(){
      this.events?.abort();this.events=new AbortController();const options={signal:this.events.signal};
      this.details=this.querySelector('details');this.trigger=this.querySelector('summary');
      this.renderLanguage=()=>this.render();
      this.addEventListener('click',event=>{
        const button=event.target.closest('[data-pl-code]');if(!button)return;
        const api=window.Weglot;if(!api?.initialized)return;
        this.details.open=false;this.trigger.focus();
        if(button.dataset.plCode!==api.getCurrentLang())api.switchTo(button.dataset.plCode);
      },options);
      this.addEventListener('keydown',event=>{
        if(event.key==='Escape'&&this.details.open){event.preventDefault();event.stopPropagation();this.details.open=false;this.trigger.focus();}
        if(event.key==='ArrowDown'&&event.target===this.trigger){event.preventDefault();this.details.open=true;this.querySelector('[aria-pressed=true]')?.focus();}
      },options);
      document.addEventListener('click',event=>{if(!this.contains(event.target))this.details.open=false;},options);
      this.addEventListener('focusout',event=>{if(event.relatedTarget&&!this.contains(event.relatedTarget))this.details.open=false;},options);
      let attempts=0;
      const connect=()=>{
        if(!this.isConnected)return;
        const api=window.Weglot;
        if(api?.on){
          this.api=api;api.on('initialized',this.renderLanguage);api.on('switchersReady',this.renderLanguage);api.on('languageChanged',this.renderLanguage);
          if(api.initialized)this.render();
        }else if(attempts++<120)this.retry=setTimeout(connect,250);
      };
      connect();
    }
    render(){
      const api=this.api;if(!api?.initialized)return;
      const languages=[api.options?.language_from,...(api.options?.languages||[]).map(language=>language.language_to)].filter(Boolean);
      if(languages.length<2)return;
      const codes=[...new Set(languages)],current=api.getCurrentLang(),list=this.querySelector('[data-pl-languages]');
      const name=api.getLanguageName(current)||current.toUpperCase();
      this.querySelector('[data-pl-current]').textContent=this.classList.contains('pl--mobile')?name:current.toUpperCase();
      this.querySelector('[data-pl-flag]').replaceChildren(this.flag(current));
      this.trigger.setAttribute('aria-label',`${this.dataset.label}: ${name}`);
      const fragment=document.createDocumentFragment();
      codes.forEach(code=>{
        const button=document.createElement('button');button.type='button';button.dataset.plCode=code;button.lang=code;button.setAttribute('aria-pressed',String(code===current));
        const badge=document.createElement('span');badge.className='pl-flag';badge.setAttribute('aria-hidden','true');badge.append(this.flag(code));
        const label=document.createElement('span');label.textContent=api.getLanguageName(code)||code.toUpperCase();
        const check=document.createElement('span');check.className='pl-check';check.textContent='✓';check.setAttribute('aria-hidden','true');
        button.append(badge,label,check);fragment.append(button);
      });
      list.replaceChildren(fragment);this.hidden=false;this.dataset.ready='true';
      document.documentElement.classList.add('pearl-language-ready');
    }
    flag(code){
      const country={nl:'nl',en:'gb',es:'es',de:'de',fr:'fr',da:'dk',sv:'se',pl:'pl',it:'it',no:'no'}[code];
      const fragment=document.createDocumentFragment(),fallback=document.createElement('span');fallback.className='pl-flag-fallback';fallback.textContent=code.toUpperCase();fragment.append(fallback);
      if(country){const image=document.createElement('img');image.src=`https://cdn.weglot.com/flags/square/${country}.svg`;image.alt='';image.width=26;image.height=26;image.addEventListener('error',()=>image.remove(),{once:true});fragment.append(image);}
      return fragment;
    }
    disconnectedCallback(){
      this.events?.abort();clearTimeout(this.retry);
      ['initialized','switchersReady','languageChanged'].forEach(event=>this.api?.off(event,this.renderLanguage));
      if(!document.querySelector('deryan-pearl-language[data-ready=true]'))document.documentElement.classList.remove('pearl-language-ready');
    }
  });
}
if (!customElements.get('deryan-pearl-header')) {
  customElements.define('deryan-pearl-header',class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();this.events=new AbortController();const options={signal:this.events.signal};
      this.menus=[...this.querySelectorAll('[data-ph-details]')];
      this.menus.forEach(menu=>menu.addEventListener('toggle',()=>{
        if(menu.open){this.menus.forEach(other=>{if(other!==menu)other.open=false;});menu.querySelectorAll('img[loading=lazy]').forEach(image=>image.loading='eager');}
        this.querySelector('[data-ph-dismiss]').classList.toggle('is-visible',this.menus.some(item=>item.open));
      },options));
      this.addEventListener('click',event=>{
        if(event.target.closest('[data-ph-dismiss]') || event.target.closest('[aria-controls]') || event.target.closest('.ph-account-panel a'))this.close();
      },options);
      document.addEventListener('click',event=>{if(!this.contains(event.target))this.close();},options);
      this.addEventListener('keydown',event=>{
        const menu=event.target.closest('[data-ph-details]');
        if(event.key==='Escape'&&menu?.open){event.preventDefault();menu.open=false;menu.querySelector('summary').focus();}
        if(event.key==='ArrowDown'&&event.target.matches('.ph-disclosure>summary')){event.preventDefault();menu.open=true;menu.querySelector('.ph-panel a')?.focus();}
      },options);
      this.addEventListener('focusout',event=>{if(event.relatedTarget&&!this.contains(event.relatedTarget))this.close();},options);
      this.breakpoint=matchMedia('(min-width:1000px)');
      this.breakpoint.addEventListener('change',()=>{this.close();document.getElementById('pearl-navigation')?.hide();},options);
      document.addEventListener('dialog:after-show',()=>this.close(),options);
      document.addEventListener('dialog:after-hide',event=>{if(event.target.id==='search-drawer'&&document.activeElement===document.body){const target=this.breakpoint.matches?this.querySelector('.ph-search'):this.querySelector('.ph-mobile-search');target?.focus({preventScroll:true});}},options);
    }
    close(){this.menus?.forEach(menu=>menu.open=false);}
    disconnectedCallback(){this.events?.abort();}
  });
}
customElements.whenDefined('x-drawer').then(()=>{
  if(customElements.get('deryan-pearl-mobile-menu'))return;
  customElements.define('deryan-pearl-mobile-menu',class extends customElements.get('x-drawer') {
    get initialFocus(){return '[data-ph-search]';}
    _setInitialPosition(){}
    connectedCallback(){
      super.connectedCallback();
      this.menuEvents?.abort();this.menuEvents=new AbortController();const options={signal:this.menuEvents.signal};
      this.querySelector('[data-ph-search]').addEventListener('click',async()=>{
        const search=document.getElementById('search-drawer');
        if(!search){location.href=this.dataset.searchUrl;return;}
        await this.hide();await search.show();
      },options);
      this.querySelectorAll('.pm-category').forEach(category=>category.addEventListener('toggle',()=>{
        if(category.open)this.querySelectorAll('.pm-category').forEach(other=>{if(other!==category)other.open=false;});
      },options));
      this.addEventListener('toggle',event=>{if(event.target===this)this.syncWidgets();},options);
      this.addEventListener('dialog:after-hide',()=>{this.querySelectorAll('details').forEach(item=>item.open=false);},options);
    }
    disconnectedCallback(){this.menuEvents?.abort();this.restoreWidgets();this.motion?.forEach(animation=>animation.cancel());super.disconnectedCallback();}
    _showTransition(animate=true){return this.transition(true,animate);}
    _hideTransition(){return this.transition(false);}
    async transition(open,animate=true){
      const revision=this.motionRevision=(this.motionRevision||0)+1;
      this.motion?.forEach(animation=>animation.cancel());
      const panel=this.shadowRoot.querySelector('[part=content]');
      panel.style.clipPath='none';this.style.visibility='visible';this.style.opacity='1';
      const reduce=this.dataset.motion==='false'||matchMedia('(prefers-reduced-motion: reduce)').matches;
      const duration=!animate||reduce?0:open?420:170;
      this.motion=[];
      if(duration){
        const overlay=this.shadowRoot.querySelector('[part=overlay]');
        if(overlay)this.motion.push(overlay.animate(open?[{opacity:0},{opacity:1}]:[{opacity:1},{opacity:0}],{duration,easing:'ease',fill:'backwards'}));
        this.motion.push(panel.animate(open?[{opacity:0,transform:'translateX(-18px) scale(.985)'},{opacity:1,transform:'none'}]:[{opacity:1,transform:'none'},{opacity:0,transform:'translateX(-12px) scale(.99)'}],{duration,easing:'cubic-bezier(.16,1,.3,1)',fill:'backwards'}));
        await Promise.all(this.motion.map(animation=>animation.finished.catch(()=>{})));
      }
      if(revision!==this.motionRevision)return;
      if(!open){this.style.visibility='hidden';this.style.opacity='0';}
    }
    syncWidgets(){
      if(!this.open){this.restoreWidgets();return;}
      this.querySelectorAll('img[loading=lazy]').forEach(image=>image.loading='eager');
      const element=document.querySelector('[data-minimal-storefront-widget-shell]');
      if(!element)return;
      this.widget={element,value:element.style.getPropertyValue('display'),priority:element.style.getPropertyPriority('display')};
      const hide=()=>{if(element.style.getPropertyValue('display')!=='none')element.style.setProperty('display','none','important');};
      hide();this.widgetObserver=new MutationObserver(hide);this.widgetObserver.observe(element,{attributes:true,attributeFilter:['style']});
    }
    restoreWidgets(){this.widgetObserver?.disconnect();if(this.widget){const {element,value,priority}=this.widget;if(value)element.style.setProperty('display',value,priority);else element.style.removeProperty('display');this.widget=null;}}
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["no-restock"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mooiys-outlet')) {
  customElements.define('mooiys-outlet', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const start = () => {
        if (this.initialized || !this.querySelector('[data-labels]')) return;
        this.initialized = true;
        this.initialize();
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start, { once: true });
      } else {
        start();
      }
    }

    initialize() {
      let map, labels;
      try {
        map = JSON.parse(this.querySelector('[data-map]').textContent);
        labels = JSON.parse(this.querySelector('[data-labels]').textContent);
      } catch {
        return;
      }
      const grid = this.querySelector('[data-grid]');
      const nodes = Array.from(grid.querySelectorAll('[data-product]'));
      if (!nodes.length) return;
      const initial = Number(this.dataset.initial) || 8;
      const step = Number(this.dataset.step) || 12;
      const state = { category: 'all', query: '', price: 'all', sort: 'featured', limit: initial };
      const groups = new Map();
      const selection = new Map();
      const normalize = (value) => String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
      const products = nodes.map((node, index) => {
        const meta = map[node.dataset.handle] || {};
        const item = {
          node, handle: node.dataset.handle,
          title: meta.name || node.dataset.title,
          fullTitle: node.dataset.title,
          category: meta.category || 'other',
          group: meta.group || node.dataset.handle,
          color: meta.color || [],
          price: Number(node.dataset.price),
          saving: Number(node.dataset.saving),
          available: node.dataset.available === 'true',
          rank: Number.isFinite(meta.rank) ? meta.rank : 1000 + index,
          index
        };
        node.querySelector('[data-title-link]').textContent = item.title;
        node.querySelector('[data-color-label]').textContent = item.color[0] || labels.categories[item.category];
        item.searchText = normalize([item.title, item.fullTitle, item.color[0], labels.categories[item.category]].join(' '));
        if (!groups.has(item.group)) groups.set(item.group, []);
        groups.get(item.group).push(item);
        return item;
      });
      const grouped = Array.from(groups.entries()).map(([id, members]) => ({
        id, members, rank: Math.min(...members.map((item) => item.rank))
      })).sort((a, b) => a.rank - b.rank);
      const categoryBox = this.querySelector('[data-categories]');
      const categoryButtons = new Map();
      const makeCategory = (key, text, count) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'mno-category';
        button.dataset.category = key;
        button.append(document.createTextNode(text));
        const badge = document.createElement('span');
        badge.textContent = count;
        button.append(badge);
        categoryBox.append(button);
        categoryButtons.set(key, button);
      };
      makeCategory('all', labels.all, products.length);
      Object.entries(labels.categories).forEach(([key, label]) => {
        const count = products.filter((item) => item.category === key).length;
        if (count) makeCategory(key, label, count);
      });
      const hex = (color) => /^#[0-9a-f]{6}$/i.test(color || '') ? color : '#808080';
      products.forEach((item) => {
        const siblings = groups.get(item.group);
        if (siblings.length < 2 || !item.color.length) return;
        const wrap = item.node.querySelector('[data-swatches]');
        wrap.replaceChildren();
        siblings.forEach((sibling) => {
          const button = document.createElement('button');
          button.className = 'mno-swatch';
          button.type = 'button';
          button.dataset.choose = sibling.handle;
          button.dataset.group = item.group;
          button.dataset.soldOut = String(!sibling.available);
          button.setAttribute('aria-label', sibling.title + ' — ' + (sibling.color[0] || sibling.fullTitle) + (sibling.available ? '' : ' — ' + labels.soldOut));
          button.setAttribute('aria-pressed', String(sibling.handle === item.handle));
          const dot = document.createElement('span');
          dot.className = 'mno-swatch-dot';
          dot.setAttribute('aria-hidden', 'true');
          dot.style.background = sibling.color[2]
            ? 'linear-gradient(135deg,' + hex(sibling.color[1]) + ' 50%,' + hex(sibling.color[2]) + ' 50%)'
            : hex(sibling.color[1]);
          button.append(dot);
          wrap.append(button);
        });
      });
      const countText = (articles, models) => articles + ' ' + (articles === 1 ? labels.article : labels.articles) + ' · ' + models + ' ' + (models === 1 ? labels.model : labels.models);
      this.querySelector('[data-total]').textContent = countText(products.length, grouped.length);
      const more = this.querySelector('[data-more]');
      const progress = this.querySelector('[data-progress]');
      const matches = (item) =>
        (state.category === 'all' || item.category === state.category) &&
        (!state.query || item.searchText.includes(normalize(state.query))) &&
        (state.price === 'all' || item.price <= Number(state.price));
      const render = () => {
        const rows = grouped.map((group) => {
          const eligible = group.members.filter(matches);
          if (!eligible.length) return null;
          const selected = eligible.find((item) => item.handle === selection.get(group.id));
          let current = selected || eligible.find((item) => item.available) || eligible[0];
          if (!selected && state.sort === 'price') current = [...eligible].sort((a,b) => a.price - b.price)[0];
          if (!selected && state.sort === 'saving') current = [...eligible].sort((a,b) => b.saving - a.saving)[0];
          return { group, eligible, current };
        }).filter(Boolean);
        if (state.sort === 'price') rows.sort((a,b) => a.current.price - b.current.price || a.group.rank - b.group.rank);
        if (state.sort === 'saving') rows.sort((a,b) => b.current.saving - a.current.saving || a.group.rank - b.group.rank);
        const fragment = document.createDocumentFragment();
        rows.slice(0, state.limit).forEach(({ current, eligible }) => {
          current.node.querySelectorAll('[data-choose]').forEach((button) => {
            button.hidden = !eligible.some((item) => item.handle === button.dataset.choose);
          });
          fragment.append(current.node);
        });
        grid.replaceChildren(fragment);
        categoryButtons.forEach((button, key) => button.setAttribute('aria-pressed', String(key === state.category)));
        this.querySelector('[data-count]').textContent = countText(rows.reduce((total,row) => total + row.eligible.length, 0), rows.length);
        this.querySelector('[data-empty]').hidden = rows.length > 0;
        this.querySelector('[data-more-wrap]').hidden = rows.length === 0;
        more.hidden = state.limit >= rows.length;
        progress.textContent = labels.viewing + ' ' + Math.min(state.limit, rows.length) + ' ' + labels.of + ' ' + rows.length + ' ' + (rows.length === 1 ? labels.model : labels.models);
        return rows;
      };
      this.addEventListener('click', (event) => {
        const category = event.target.closest('[data-category]');
        if (category && this.contains(category)) {
          state.category = category.dataset.category;
          state.limit = initial;
          render();
        }
        const swatch = event.target.closest('[data-choose]');
        if (swatch && this.contains(swatch)) {
          const handle = swatch.dataset.choose;
          selection.set(swatch.dataset.group, handle);
          render();
          const current = products.find((item) => item.handle === handle);
          const focused = Array.from(current.node.querySelectorAll('[data-choose]')).find((button) => button.dataset.choose === handle);
          if (focused) focused.focus({ preventScroll: true });
        }
      });
      this.querySelector('[data-search]').addEventListener('input', (event) => {
        state.query = event.target.value;
        state.limit = initial;
        render();
      });
      this.querySelector('[data-price]').addEventListener('change', (event) => {
        state.price = event.target.value;
        state.limit = initial;
        render();
      });
      this.querySelector('[data-sort]').addEventListener('change', (event) => {
        state.sort = event.target.value;
        render();
      });
      more.addEventListener('click', () => {
        const previous = state.limit;
        state.limit += step;
        const rows = render();
        rows[previous]?.current.node.querySelector('[data-title-link]')?.focus({ preventScroll: true });
      });
      render();
      this.querySelector('[data-toolbar]').hidden = false;
      categoryBox.hidden = false;
    }
  });
}



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-drawer"]) return;
  try {
    
(() => {
  customElements.whenDefined('search-drawer').then(() => {
    if (customElements.get('deryan-pearl-search')) return;
    class DeryanPearlSearch extends customElements.get('search-drawer') {
      get initialFocus() { return '#PearlSearchInput'; }
      get shouldAppendToBody() { return false; }
      get reduceMotion() { return this.dataset.motion === 'false' || matchMedia('(prefers-reduced-motion: reduce)').matches || !!window.themeVariables?.settings?.reduceDrawerAnimation; }
      connectedCallback() {
        super.connectedCallback();
        this.searchEvents?.abort();
        this.searchEvents = new AbortController();
        const options = {signal:this.searchEvents.signal};
        this.form = this.querySelector('form');
        this.input = this.form.elements.q;
        this.results = this.querySelector('[data-pearl-search-results]');
        this.idle = this.querySelector('[data-search-idle]');
        this.loading = this.querySelector('[data-search-loading]');
        this.error = this.querySelector('[data-search-error]');
        this.status = this.querySelector('[data-search-status]');
        this.bottom = this.querySelector('[data-search-bottom]');
        this.clear = this.querySelector('[type=reset]');
        this.cache ||= new Map();
        this.input.addEventListener('input', event => { if (!event.isComposing) this.onInput(); }, options);
        this.input.addEventListener('compositionend', () => this.onInput(), options);
        this.input.addEventListener('keydown', event => this.onKeydown(event), options);
        this.form.addEventListener('reset', event => {
          event.preventDefault();
          this.input.value = '';
          this.onInput();
          this.input.focus({preventScroll:true});
        }, options);
        this.form.addEventListener('submit', event => {
          if (!this.input.value.trim()) { event.preventDefault(); this.input.focus(); }
        }, options);
        this.addEventListener('click', event => {
          const quick = event.target.closest('[data-search-term]');
          if (!quick) return;
          this.input.value = quick.dataset.searchTerm;
          this.input.focus({preventScroll:true});
          this.onInput(true);
        }, options);
        this.addEventListener('dialog:after-hide', () => {
          clearTimeout(this.debounceTimer);
          this.request?.abort();
          this.setActive(-1);
          this.input.setAttribute('aria-expanded','false');
        }, options);
        this.addEventListener('dialog:after-show', () => {
          if (this.input.value.trim()) this.onInput(true);
        }, options);
        this.syncViewport = () => {
          const viewport = window.visualViewport;
          this.style.setProperty('--pearl-viewport-height',(viewport?.height || innerHeight)+'px');
          this.style.setProperty('--pearl-viewport-top',(viewport?.offsetTop || 0)+'px');
        };
        window.addEventListener('resize',this.syncViewport,options);
        window.visualViewport?.addEventListener('resize',this.syncViewport,options);
        window.visualViewport?.addEventListener('scroll',this.syncViewport,options);
        this.syncViewport();
        this.addEventListener('toggle', event => { if (event.target === this) this.syncWidget(); }, options);
      }
      disconnectedCallback() {
        this.searchEvents?.abort();
        this.unlockPageScroll();
        this.restoreWidget();
        this.request?.abort();
        clearTimeout(this.debounceTimer);
        this.motion?.forEach(animation => animation.cancel());
        super.disconnectedCallback();
      }
      show(animate = true) {
        const result = super.show(animate);
        this.input?.focus({preventScroll:true});
        return result;
      }
      lockPageScroll() {
        if (this.pageScrollLock || !matchMedia('(max-width:999px)').matches) return;
        this.pageScrollLock = {x:window.scrollX,y:window.scrollY};
        document.documentElement.style.setProperty('--pearl-search-scroll-top',`${-this.pageScrollLock.y}px`);
        document.documentElement.classList.add('pearl-search-page-locked');
        this.syncViewport?.();
      }
      unlockPageScroll() {
        if (!this.pageScrollLock) return;
        const {x,y} = this.pageScrollLock;
        this.pageScrollLock = null;
        document.documentElement.classList.remove('pearl-search-page-locked');
        document.documentElement.style.removeProperty('--pearl-search-scroll-top');
        window.scrollTo({left:x,top:y,behavior:'instant'});
      }
      _setInitialPosition() {}
      _showTransition(animate = true) { return this.transition(true,animate); }
      _hideTransition() { return this.transition(false); }
      async transition(open,animate = true) {
        if (open) this.lockPageScroll();
        const revision = this.motionRevision = (this.motionRevision || 0)+1;
        const panel = this.shadowRoot.querySelector('[part=content]');
        const overlay = this.shadowRoot.querySelector('[part=overlay]');
        const interrupted = this.motion?.some(item => item.playState === 'running');
        const start = {opacity:getComputedStyle(panel).opacity,transform:getComputedStyle(panel).transform};
        this.motion?.forEach(item => item.cancel());
        this.style.visibility = 'visible';
        this.style.opacity = '1';
        panel.style.clipPath = 'none';
        const duration = !animate || this.reduceMotion ? 0 : open ? 460 : 190;
        this.motion = [];
        if (duration) {
          const end = {opacity:0,transform:'translateY(-14px) scale(.985)'};
          this.motion.push(panel.animate(open ? [interrupted ? start : end,{opacity:1,transform:'none'}] : [start,end],{duration,easing:open ? 'cubic-bezier(.16,1,.3,1)' : 'ease-in',fill:'backwards'}));
          this.motion.push(overlay.animate([{opacity:open ? 0 : 1},{opacity:open ? 1 : 0}],{duration:open ? 300 : 180,fill:'backwards'}));
          await Promise.all(this.motion.map(item => item.finished.catch(() => {})));
        }
        if (revision !== this.motionRevision) return;
        if (!open) { this.style.visibility = 'hidden'; this.style.opacity = '0'; this.unlockPageScroll(); }
      }
      restoreWidget() {
        this.searchWidgetObserver?.disconnect();
        if (this.searchWidget) {
          const {element,value,priority} = this.searchWidget;
          if (value) element.style.setProperty('display',value,priority);
          else element.style.removeProperty('display');
          this.searchWidget = null;
        }
      }
      syncWidget() {
        if (!this.open) { this.restoreWidget(); return; }
        const hide = () => {
          const element = document.querySelector('[data-minimal-storefront-widget-shell]');
          if (!element) return false;
          if (!this.searchWidget) this.searchWidget = {element,value:element.style.getPropertyValue('display'),priority:element.style.getPropertyPriority('display')};
          if (element.style.getPropertyValue('display') !== 'none') element.style.setProperty('display','none','important');
          return element;
        };
        this.searchWidgetObserver?.disconnect();
        const element = hide();
        this.searchWidgetObserver = new MutationObserver(() => {
          const found = hide();
          if (found && !element) { this.searchWidgetObserver.disconnect(); this.searchWidgetObserver.observe(found,{attributes:true,attributeFilter:['style']}); }
        });
        if (element) this.searchWidgetObserver.observe(element,{attributes:true,attributeFilter:['style']});
        else this.searchWidgetObserver.observe(document.body,{childList:true,subtree:true});
      }
      onInput(immediate = false) {
        clearTimeout(this.debounceTimer);
        this.request?.abort();
        this.queryRevision = (this.queryRevision || 0)+1;
        this.setActive(-1);
        const term = this.input.value.trim();
        this.clear.hidden = !this.input.value;
        this.bottom.hidden = !term;
        this.idle.hidden = !!term;
        this.results.hidden = true;
        this.error.hidden = true;
        this.loading.hidden = !term;
        this.input.setAttribute('aria-expanded','false');
        this.results.setAttribute('aria-busy',term ? 'true' : 'false');
        this.status.textContent = term ? this.dataset.loadingLabel : '';
        if (!term) return;
        const revision = this.queryRevision;
        if (immediate) this.search(term,revision);
        else this.debounceTimer = setTimeout(() => this.search(term,revision),240);
      }
      async search(term,revision) {
        this.request = new AbortController();
        const request = this.request;
        const timeout = setTimeout(() => request.abort(),8000);
        const cacheKey = document.documentElement.lang+'|'+term.toLocaleLowerCase();
        try {
          let markup = this.cache.get(cacheKey);
          if (!markup) {
            let predictive = true;
            try { predictive = JSON.parse(document.getElementById('shopify-features')?.textContent || '{}').predictiveSearch !== false; } catch {}
            const url = new URL(predictive ? this.dataset.suggestUrl : this.dataset.searchUrl,location.origin);
            url.searchParams.set('q',term);
            url.searchParams.set('section_id',this.dataset.sectionId);
            if (predictive) {
              url.searchParams.set('resources[type]','product,query,collection,page');
              url.searchParams.set('resources[limit]','4');
              url.searchParams.set('resources[limit_scope]','each');
              url.searchParams.set('resources[options][unavailable_products]','last');
            } else {
              url.searchParams.set('type','product,page');
              url.searchParams.set('options[prefix]','last');
            }
            const response = await fetch(url,{signal:request.signal,headers:{Accept:'text/html'}});
            if (!response.ok) throw new Error('Search unavailable');
            const parsed = new DOMParser().parseFromString(await response.text(),'text/html');
            const fragment = parsed.querySelector('[data-pearl-search-results]');
            if (!fragment || !fragment.querySelector('[data-result-status]')) throw new Error('Search response unavailable');
            markup = fragment.innerHTML;
            this.cache.set(cacheKey,markup);
            if (this.cache.size > 20) this.cache.delete(this.cache.keys().next().value);
          }
          if (revision !== this.queryRevision || !this.open || this.input.value.trim() !== term) return;
          this.results.innerHTML = markup;
          this.results.hidden = false;
          const count = this.results.querySelectorAll('[role=option]').length;
          this.input.setAttribute('aria-expanded',count ? 'true' : 'false');
          this.status.textContent = this.results.querySelector('[data-result-status]')?.textContent || '';
          if (!this.reduceMotion) {
            this.results.querySelectorAll('.pearl-search-product').forEach((card,index) => {
              card.animate([{opacity:0,transform:'translateY(8px)'},{opacity:1,transform:'none'}],{duration:300,delay:index*30,easing:'cubic-bezier(.16,1,.3,1)',fill:'backwards'});
            });
          }
        } catch {
          if (revision !== this.queryRevision || !this.open) return;
          this.error.hidden = false;
          this.status.textContent = this.dataset.errorLabel;
        } finally {
          clearTimeout(timeout);
          if (revision === this.queryRevision) {
            this.loading.hidden = true;
            this.results.setAttribute('aria-busy','false');
          }
        }
      }
      options() {
        if (this.results.hidden) return [];
        const options = Array.from(this.results.querySelectorAll('[role=option]'));
        if (matchMedia('(max-width:699px)').matches) options.sort((a,b) => Number(b.classList.contains('pearl-search-product'))-Number(a.classList.contains('pearl-search-product')));
        return options;
      }
      setActive(index) {
        this.activeIndex = index;
        this.input?.removeAttribute('aria-activedescendant');
        this.results?.querySelectorAll('[aria-selected=true]').forEach(item => item.setAttribute('aria-selected','false'));
        const selected = this.options()[index];
        if (!selected) return;
        selected.setAttribute('aria-selected','true');
        this.input.setAttribute('aria-activedescendant',selected.id);
        selected.scrollIntoView({block:'nearest'});
      }
      onKeydown(event) {
        if (event.isComposing) return;
        const options = this.options();
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          if (!options.length) return;
          event.preventDefault();
          const direction = event.key === 'ArrowDown' ? 1 : -1;
          this.setActive(this.activeIndex < 0 ? (direction > 0 ? 0 : options.length-1) : (this.activeIndex+direction+options.length)%options.length);
        } else if (event.key === 'Enter' && this.activeIndex >= 0 && options[this.activeIndex]) {
          event.preventDefault();
          options[this.activeIndex].click();
        } else if (event.key === 'Escape') {
          event.preventDefault();
          this.hide();
        } else if (event.key === 'Tab') this.setActive(-1);
      }
    }
    customElements.define('deryan-pearl-search',DeryanPearlSearch);
  });
})();


  } catch(e) { console.error(e); }
})();
})();
